// extracted by mini-css-extract-plugin
export var fullHeightState = "_19-7";
export var headerCell = "_19-1";
export var loadingStateCell = "_19-4";
export var rowWrapper = "_19-3";
export var standaloneTable = "_19-8";
export var standaloneTableWithBodyFill = "_19-9";
export var stateCell = "_19-5";
export var table = "_19-0";
export var tableBodyFiller = "_19-6";
export var white = "_19-2";